import styled from 'styled-components';

import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';

export const StyledContainer = styled(Container)<{ component?: React.ElementType }>`
  position: relative;
  z-index: 3;
`;

export const StyledPaper = styled(Paper)`
  background-image: none;
  background-color: rgba(0, 0, 0, 0.65);
  /* border: 1px solid rgba(255, 255, 255, 0.3); */
  backdrop-filter: blur(6px)
`;

export const StyledFormContainer = styled.div<{ noWrap?: boolean; }>`
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: ${props => props.noWrap ? "nowrap" : "wrap"};;
  justify-content: space-between;

  margin: 2rem 0 0;
`;